import {ReactElement, RefCallback, useState} from 'react';

import {asPreviewVideoHandle, PreviewVideoHandleType} from './review-preview-video-types';
import * as styles from './review-preview-video.scss';

type PropsType = {
    src: string;
    videoRef: RefCallback<PreviewVideoHandleType | null>;
};

export function ReviewPreviewVideoPlayer(props: PropsType): ReactElement | null {
    const {src, videoRef} = props;
    const [hasError, setHasError] = useState(false);

    if (hasError) {
        return null;
    }

    return (
        // eslint-disable-next-line jsx-a11y/media-has-caption -- user-uploaded review attachments have no captions
        <video
            autoPlay
            className={styles.ReviewPreviewVideo_player}
            controls
            disablePictureInPicture
            onError={() => setHasError(true)}
            playsInline
            ref={(node) => videoRef(asPreviewVideoHandle(node))}
            src={src}
        />
    );
}
